export { CheckBox, CheckBoxProps } from '@ui-kitten/components';
